<template>
  <get-started title="Live Jobs">
    <div class="d-flex px-1 py-3 my-3">
      <b-container class="zindex-1">
        <b-row>
          <b-col>
            <div class="pr-1">
              <p>
                Captain Live Encoder is a real-time video service that lets you
                create live outputs for broadcast and streaming delivery. It is
                a new feature that allows you to even encode live streams. Live
                Encoder is able to deploy anywhere and deliver everywhere
                encoded solutions. It processes video and audio in real time for
                streaming to internet connected devices, for broadcasting and
                multiscreen delivery at scale.
              </p>
              <p>
                Live makes it simple to compress
                your videos in multiple versions for distributions; including
                different qualities, segment control and length.
                It is easy to use and configure, reliable, high quality live encoding within
                the studio, inside remote facilities or on any location. You can
                control live via web interface or API for easy integration and
                appliance, cloud based, virtual deployment.
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="pl-1">
              <p>
                You can control live via web interface or API for easy integration and
                appliance, cloud based, virtual deployment. Easy to update
                software lets you keep pace with features and standards as
                screens, devices and viewer expectations changes. Easy to update
                software lets you keep pace with features and standards as
                screens, devices and viewer expectations changes.
              </p>
              <slot />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </get-started>
</template>

<script>
import GetStarted from '@/components/start/GetStarted.vue'

export default {
  name: 'LiveJobsIntro',
  components: { GetStarted },
  computed: {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>

</style>
